// Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import {
  Facebook,
  Instagram,
  Twitter,
  Linkedin,
} from "lucide-react";

import logo from "../../../assets/images/logo.png";
import "../../../assets/css/user/footer/Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="ft-footer">
      <div className="ft-container">

        {/* Logo Section */}
        <div className="ft-logo">
          <img
            src={logo}
            alt="PULSEapp Logo"
            className="ft-logo-img"
          />

          <p className="ft-tagline">
            Pakistan's marketplace for time-limited deals.
          </p>

         
        </div>

        {/* Navigation Column */}
        <div className="ft-column">
          <h3 className="ft-title">Navigation</h3>

          <ul className="ft-links">
            <li>
              <Link to="/">Home</Link>
            </li>

            <li>
              <Link to="/deals">Deals</Link>
            </li>

            <li>
              <Link to="/shop">Shops</Link>
            </li>

         
          </ul>
        </div>

        {/* My Account Column */}
        <div className="ft-column">
          <h3 className="ft-title">My Account</h3>

          <ul className="ft-links">
            <li>
              <Link to="/login">Login</Link>
            </li>

            <li>
              <Link to="/signup">Sign Up</Link>
            </li>

            <li>
              <Link to="/customer-setting">Settings</Link>
            </li>

          

          
          </ul>
        </div>

        {/* Deals / Information Column */}
        <div className="ft-column">
          <h3 className="ft-title">Deals</h3>

          <ul className="ft-links">
            

               <li>
              <Link to="/blog">Blog</Link>
            </li>

            

            <li>
              <Link to="/about-us">About Us</Link>
            </li>

            

            

            <li>
              <Link to="/contact-us">Contact Us</Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="ft-bottom">
        <p>
          © {currentYear} PULSEapp - Powered By{" "}
          <a
            href="#"
            className="ft-bottom-link"
          >
            Behind The Software
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;